import { Col, Spinner } from "reactstrap";
import { findOutClassStatBoxes } from "./Utility";
import typography from "./typography";

export default function EngagementStatBoxes({ data = {}, isVertical = false, loading = false }) {
  const ENGAGEMENT_BOXES = [
    {
      HEADING: typography.ENGAGED_USERS,
      COUNT: data?.engagedUsers ?? 0,
    },
    {
      HEADING: typography.DELETED_USERS,
      COUNT: data?.deletedUsers ?? 0,
    },
    {
      HEADING: typography.IDLE_USERS,
      COUNT: data?.idleUsers ?? 0,
    },
    {
      HEADING: typography.SIGNUPS,
      COUNT: data?.signups ?? 0,
    },
  ];

  const cardColumnProps = isVertical
    ? { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" }
    : { xl: "3", md: "6", sm: "6", xs: "12" };

  return (
    <>
      {ENGAGEMENT_BOXES.map((el, idx) => (
        <Col {...cardColumnProps} className="mb-3" key={idx}>
          <div className={`stat-boxes-con p-3 ${findOutClassStatBoxes(el.HEADING)}`}>
            <p className="standard-typo-14-500-ld ft-white">{el.HEADING}</p>
            {loading ? (
              <div className="d-flex align-items-center" style={{ height: 90 }}>
                <Spinner size="sm" color="light" />
              </div>
            ) : (
              <h1 className="ft-white stat-box-heading font-family-lexend">{el.COUNT}</h1>
            )}
          </div>
        </Col>
      ))}
    </>
  );
}
